import { httpRequest } from "@services/http"

export class CommandDeleteEngagementLaunchPolicy {
  async run(engagementId: number, launchId: number): Promise<void> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/policies/budget/`
    await httpRequest(url, { method: "DELETE", body: { launch_id: launchId } })
  }
}
